import { useCallback } from 'react';
import { GridColDef } from '@mui/x-data-grid-pro';
import { useAccrualDatesQuery } from './useAccrualDatesQuery';
import { useAccrualDatesTableState } from './useAccrualDatesTableState';
import { useTranslation } from 'react-i18next';

export const useAccrualDatesTable = () => {
    const { t } = useTranslation();
    const { rows, setRows, loading, setLoading, loadData } = useAccrualDatesQuery();
    const { contextMenu, setContextMenu, selectedRow, setSelectedRow, selected, setSelected, cleanSelected } = useAccrualDatesTableState();

    const columns: GridColDef[] = [
        { field: 'name', headerName: t('accruals.accrual_dates.table.columns.name'), flex: 1 },
        { field: 'date_local_format', headerName: t('accruals.accrual_dates.table.columns.date'), flex: 1, headerAlign: 'center', align: 'center', filterable: false },
        { field: 'type_date', headerName: t('accruals.accrual_dates.table.columns.type_date'), flex: 1, headerAlign: 'center', align: 'center', filterable: false },
    ];

    const reloading = useCallback(() => {
        //const permissions = JSON.parse(localStorage.getItem('permissions') || '[]') as string[];
        //const canReadAccrualDates = permissions.includes('timekeeper.GetAllAccrualDates');

        /* if (canReadAccrualDates) {
            loadData().finally(() => {
                setContextMenu(null);
                cleanSelected();
            });
        } else {
            setRows([]);
            setLoading(false);
        } */
        loadData()
            .catch(() => {
                setRows([]);
                setLoading(false);
            })
            .finally(() => {
                setContextMenu(null);
                cleanSelected();
            });
    }, [cleanSelected, loadData, setContextMenu, setLoading, setRows]);

    return {
        columns,
        rows,
        setRows,
        loading,
        setLoading,
        contextMenu,
        setContextMenu,
        selectedRow,
        setSelectedRow,
        selected,
        setSelected,
        cleanSelected,
        reloading,
    };
};
